import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  cycleCountAnalysisReportInitCycleCountAnalysis: null,
  cycleCountAnalysisReportInitCycleCountAnalysisSuccess: ['criteria'],
  cycleCountAnalysisReportCycleCountAnalysis: ['formikBag', 'criteria'],
  cycleCountAnalysisReportCycleCountAnalysisSuccess: ['criteria', 'reportData'],
  cycleCountAnalysisReportReportLoading: ['boolean'],

  cycleCountAnalysisReportFetchItemOptions: ['search'],
  cycleCountAnalysisReportFetchItemOptionLoading: ['boolean'],
  cycleCountAnalysisReportFetchItemOptionSuccess: ['options'],

  cycleCountAnalysisReportFetchItemGroup01Options: ['search'],
  cycleCountAnalysisReportFetchItemGroup01OptionLoading: ['boolean'],
  cycleCountAnalysisReportFetchItemGroup01OptionSuccess: ['options'],

  cycleCountAnalysisReportFetchItemGroup02Options: ['search'],
  cycleCountAnalysisReportFetchItemGroup02OptionLoading: ['boolean'],
  cycleCountAnalysisReportFetchItemGroup02OptionSuccess: ['options'],

  cycleCountAnalysisReportFetchItemGroup03Options: ['search'],
  cycleCountAnalysisReportFetchItemGroup03OptionLoading: ['boolean'],
  cycleCountAnalysisReportFetchItemGroup03OptionSuccess: ['options'],

  cycleCountAnalysisReportFetchStorageBinOptions: ['search'],
  cycleCountAnalysisReportFetchStorageBinOptionLoading: ['boolean'],
  cycleCountAnalysisReportFetchStorageBinOptionSuccess: ['options'],

  cycleCountAnalysisReportFetchStorageRowOptions: ['search'],
  cycleCountAnalysisReportFetchStorageRowOptionLoading: ['boolean'],
  cycleCountAnalysisReportFetchStorageRowOptionSuccess: ['options'],

  cycleCountAnalysisReportFetchStorageBayOptions: ['search'],
  cycleCountAnalysisReportFetchStorageBayOptionLoading: ['boolean'],
  cycleCountAnalysisReportFetchStorageBayOptionSuccess: ['options'],

  cycleCountAnalysisReportFetchLocationOptions: ['search'],
  cycleCountAnalysisReportFetchLocationOptionLoading: ['boolean'],
  cycleCountAnalysisReportFetchLocationOptionSuccess: ['options']
});

export const CycleCountAnalysisReportTypes = Types;
export default Creators;
